import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import get from 'lodash/get';
import set from 'lodash/set';
import cloneDeep from 'lodash/cloneDeep';
import CoreDtwinStateOutboundConfigsIec104Push from './outboundConfigs/iec104Push.vue';
var CONNECTOR_COMPONENT_MAP = {
  'bridge-IEC-60870-5-104-push': 'core-dtwin-state-outbound-configs-iec-104-push'
};
export default {
  name: 'CoreDtwinStateEditOutboundConfig',
  components: {
    CoreDtwinStateOutboundConfigsIec104Push: CoreDtwinStateOutboundConfigsIec104Push
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    connectors: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: _objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled'])),
  created: function created() {
    // reactivity does not work without this, no idea what the issue is
    this.$emit('input', cloneDeep(this.value));
  },
  methods: {
    get: get,
    getNumberOfValidConfigs: function getNumberOfValidConfigs() {
      var _this = this;

      // return number of configs that have a valid connectorId
      return get(this.value, 'properties.outboundConfiguration', []).filter(function (c) {
        return _this.doesConnectorIdExist(c.connectorId);
      }).length;
    },
    add: function add(index) {
      var configs = get(this.value, 'properties.outboundConfiguration', []);
      configs.splice(index + 1, 0, {});
      var newValue = cloneDeep(this.value);
      set(newValue, 'properties.outboundConfiguration', configs);
      this.$emit('input', newValue);
    },
    remove: function remove(index) {
      // get configs
      var configs = get(this.value, 'properties.outboundConfiguration', []); // remove config at index

      configs.splice(index, 1);

      if (this.getNumberOfValidConfigs() === 0) {
        // if there are no valid configs left, add an empty one
        configs.push({});
      }

      var newValue = cloneDeep(this.value);
      set(newValue, 'properties.outboundConfiguration', configs);
      this.$emit('input', newValue);
    },
    getComponentForConnectorId: function getComponentForConnectorId(connectorId) {
      var connectorById = this.connectors.find(function (c) {
        return c.id === connectorId;
      });
      return CONNECTOR_COMPONENT_MAP[(connectorById || {}).type];
    },
    doesConnectorIdExist: function doesConnectorIdExist(connectorId) {
      if (!connectorId) {
        // if config has no connectorId, it is a new config
        return true;
      } // return true if connectorId exists in list of connectors


      return this.connectors.some(function (c) {
        return c.id === connectorId;
      });
    }
  }
};